"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const popover_1 = __importDefault(require("antd/lib/popover"));
const useElementSize_1 = require("../hooks/useElementSize");
const HiddenText_1 = __importDefault(require("../HiddenText"));
/*
  Antd's popup width depends on the width of its container. This can be problematic when the trigger element is as
  small as an icon. We HAVE to manually set the width in order to prevent shrinking (and also to prevent a weird
  resizing bug caused internally by rc-align component).

  We want full control over the popup's width: we want the content to not wrap until the content width exceeds
  the `maxWidth` prop, then we want the content to wrap.

  There are 2 cases:
    1. Without wrapping, the content width is smaller than `maxWidth`: We simply prevent the content from wrapping.
    2. If it were not to wrap, the content width would exceed `maxWidth`: We set a fixed width of `maxWidth` and we
       allow content wrapping.

  To know at all times the width of the content if it were not to wrap, the content is rendered twice, one of which
  will be hidden  with `visibility: hidden` and `white-space: nowrap` and will be used solely for size measurements.
  (See element with className "hidden-content")
*/
const Tooltip = (_a) => {
    var { accessibleWhenInvisible = true, children, className, content, getPopupContainer, placement, autoAdjustOverflow = true, trigger, maxWidth = 320, overlayClassName, overlayStyle, onVisibleChange, title, visible } = _a, props = __rest(_a, ["accessibleWhenInvisible", "children", "className", "content", "getPopupContainer", "placement", "autoAdjustOverflow", "trigger", "maxWidth", "overlayClassName", "overlayStyle", "onVisibleChange", "title", "visible"]);
    const [showHiddenAccessibleContent, setShowHiddenAccessibleContent] = (0, react_1.useState)(accessibleWhenInvisible && !visible);
    const visibilityChangeHandler = (newVisible) => {
        if (accessibleWhenInvisible) {
            setShowHiddenAccessibleContent(!newVisible);
        }
        if (onVisibleChange) {
            onVisibleChange(newVisible);
        }
    };
    const hiddenNoWrapContentRef = (0, react_1.useRef)(null);
    const hiddenNoWrapContentSize = (0, useElementSize_1.useElementSize)(hiddenNoWrapContentRef);
    const shouldContentWrap = hiddenNoWrapContentSize.width > maxWidth;
    const popupInnerContent = (react_1.default.createElement(react_1.default.Fragment, null,
        title && react_1.default.createElement("div", { className: "gerudo-tooltip-title" }, title),
        content && react_1.default.createElement("div", { className: "gerudo-tooltip-description" }, content)));
    const popupContent = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)("displayed-content", { wrap: shouldContentWrap }) }, popupInnerContent),
        react_1.default.createElement("div", { className: "hidden-content", ref: hiddenNoWrapContentRef }, popupInnerContent)));
    const popupClassName = (0, classnames_1.default)(overlayClassName, "gerudo-tooltip-popup");
    const popupCustomStyle = Object.assign(Object.assign({}, overlayStyle), { "--tooltip-content-max-width": `${maxWidth}px` });
    return (react_1.default.createElement("span", Object.assign({ className: (0, classnames_1.default)("gerudo-tooltip", className) }, props),
        react_1.default.createElement(popover_1.default, { autoAdjustOverflow: autoAdjustOverflow, content: popupContent, getPopupContainer: getPopupContainer || ((triggerNode) => triggerNode.parentElement), onVisibleChange: visibilityChangeHandler, overlayClassName: popupClassName, overlayStyle: popupCustomStyle, placement: placement, trigger: trigger, visible: visible }, children),
        showHiddenAccessibleContent && (react_1.default.createElement(HiddenText_1.default, null,
            title && react_1.default.createElement("span", null, title),
            content && react_1.default.createElement("span", null, content)))));
};
exports.Tooltip = Tooltip;
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map